<template>
  <v-card
    :style="`height: calc(100vh - 74px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
    class="col-12 pb-0"
  >
    <v-row
      class="mx-0 px-2"
    >
      <v-select
        v-model="project"
        :items="projectList"
        label="Project"
        class="package-project_selector"
        style="max-width: 200px"
      />

      <date-picker
        v-model="from"
        label="Date From"
        style="max-width: 140px"
      />

      <date-picker
        v-model="to"
        label="Date To"
        style="max-width: 140px"
      />

      <v-btn
        color="info"
        class="mt-3 ml-3"
        :loading="loading"
        :disabled="loading"
        @click="search"
      >
        Search
      </v-btn>
    </v-row>

    <v-data-table
      :class="`bonus-tools-dt ${$store.state.auth.checkAccess({key: 'kiosk.access', value: true}) ? 'padding-footer' : ''}`"
      :loading="loading"
      :server-items-length="total"
      :headers="headers"
      fixed-header
      item-key="task_id"
      :options.sync="options"
      :items="filteredItems"
      :footer-props="{'items-per-page-options':[ 50, 100, 200 ]}"
      :items-per-page="50"
      :height="`calc(100vh - 215px - ${!$store.state.auth.default_user ? '0px' : '24px'})`"
      style="z-index: 0; position: relative;"
    >
      <template v-slot:body.prepend>
        <tr v-if="Object.keys(filters).length > 0" class="report-filter-row grey lighten-3">
          <td
            v-for="header in headers"
            :key="header.value"
            style="height: auto"
          >
            <v-select
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'select'"
              hide-details
              dense
              small
              multiple
              clearable
              persistent-hint
              single-line
              class="ma-0 pa-0"
              :items="filters[header.value].values || columnValueList(header.value)"
              :style="{width: (filters[header.value] || {width: false}).width}"
              v-model="filters[header.value].data"
            ></v-select>
            <v-text-field
              class="ma-0 pa-0"
              v-if="filters.hasOwnProperty(header.value) && filters[header.value].type == 'text'"
              v-model="filters[header.value].data"
              :style="{width: (filters[header.value] || {width: false}).width}"
              hide-details
            ></v-text-field>
          </td>
        </tr>
      </template>

      <template v-slot:item.action="{ item }">
        <div @click="reloadTask(item)" style="white-space: nowrap">
          <v-icon  @click="selected = item">
            mdi-reload
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </v-card>
</template>

<style scoped>
  .package-project_selector {
    max-width: 300px;
  }
</style>


<script>
  import {  filter, get, map } from 'lodash'
  import { API } from '@/utils/api'
  import moment from 'moment'
  import DatePicker from '@/components/core/DatePicker/DatePicker.vue'

  export default {
    components: {
      DatePicker
    },
    data: () => ({
      loading: false,

      from: moment().format('YYYY-MM-DD'),
      to: moment().format('YYYY-MM-DD'),

      project: null,
      items: [],
      total: 0,

      filters: {
        benefit_name: { data: [], type: 'text' },
        status: { data: [], type: 'select', width: '150px' },
        name: { data: [], type: 'text' },
        task_id: { data: [], type: 'text' },
      },
      headers: [
        { text: 'ID', value: 'task_id' },
        { text: 'Benefit Name', value: 'benefit_name' },
        { text: 'Status', value: 'status' },
        { text: 'Name', value: 'name' },
        { text: 'Start', value: 'start' },
        { text: 'End', value: 'end' },
        { text: 'Created', value: 'created' },
        { text: 'Updated', value: 'updated' },
        { text: '', value: 'action' },
      ],
      options: {},
      selected: null,
    }),

    computed: {
      projectList: function () {
        return map(this.$store.state.auth.entities, (i) => ({ text: i.name, value: i.entity_id }))
      },
      filteredItems: function () {
        return this.items.filter(d => {
          return Object.keys(this.filters).every(f => {
            try {
              if (this.filters[f].data.length > 1 && typeof this.filters[f].data == 'string' && this.filters[f].data.toString().match(/^[><=!]{1,2}/)) {
                let filter = this.filters[f].data
                if (this.filters[f].data.toString().match(/^[><=!]{1,2}/)[0] == '=') filter = '=' + this.filters[f].data
                return eval(d[f].toString() + filter)
              }
            } catch (e) {
              return true
            }
            return this.filters[f].data.length < 1
              || (this.filters[f].data.includes((d[f] || ''))
                || (this.filters[f].data.includes(true) && ((d[f] || '').toString().toLowerCase()).length > 0)
                || (this.filters[f].data.includes(false) && ((d[f] || '').toString().toLowerCase()).length == 0)
                || (typeof d[f] != 'boolean' && ((d[f] || '').toString().toLowerCase()).indexOf(this.filters[f].data.toString().toLowerCase()) >= 0))
          })
        })
      },
    },

    watch: {
      options: {
        handler () {
          this.search()
        },
        deep: true
      },
    },

    mounted () {
      if (!this.project) {
        this.project = this.projectList[0].value
      }
    },
    methods: {
      columnValueList (val) {
        return filter(this.items.map(d => d[val]), (i) => i)
      },

      async reloadTask (task) {

        if (!(await this.$root.$confirm('Confirm', `Warning: This action is irreversible. Please confirm the Task #${task.task_id} restart`))) {
          return
        }

        this.loading = true
        try {
          await API.call('/bonus_tools/task/rerun.json', {
            task_id: task.task_id,
          }, null, task.entity_id).then(resp => {
            return resp.data
          })
        } catch (e) {
        } finally {
          this.loading = false
          await this.search()
        }
      },
      search: function () {
        this.loading = true
        if (!this.project) {
          this.project = this.projectList[0].value
        }

        try {
          API.call('/bonus_tools/task/list.json', {
            ...this.options,
            from: this.from,
            to: this.to,
          }, null, this.project).then(resp => {

            this.items = get(resp, 'data', [])
            if (get(resp, 'total', false)) {
              this.total = resp.total
            }
            return resp.data
          }).catch(e => {
          }).finally(() => {
            this.loading = false
          })
        } catch (e) {
          this.loading = false
          console.log(e)
        }
      },
    }
  }
</script>
